import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import AppBar from '../../commons/AppBar'
import {List, ListItem} from '@material-ui/core'

export default class Administrare extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    goToPage = (link) =>{
        this.props.history.push(link)
    }

    componentDidMount() {
    }
    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.administrare} />

                <div className='container'>

                    <List style={{ width: '100%', maxWidth: 500, margin: 'auto' }}>
                        <ListItem onClick={() => { this.goToPage('/messenger') }} style={{ justifyContent: 'center' }} button>
                            <h3 className='pm-title'>{this.dictionary.administrare.mesagerie}</h3>
                        </ListItem>
                       
                    </List>
                </div>
            </div>
        );
    }
}